import { MapWidget } from '../application/javascripts/react_components/maps/map_widget';
import OriginalLanguageButton from '../components/shared/OriginalLanguageButton';
import WaypointPopup from '../components/shared/MapPopups/WaypointPopup';
import PhotoPopup from '../components/shared/MapPopups/PhotoPopup';
import TrailHoverCard from '../components/cards/TrailHoverCard';
import TrackHoverCard from '../components/cards/TrackHoverCard';
import GlobalActions from '../components/GlobalActions';

const ReactRailsUJS = require('react_ujs');

const context = {
  MapWidget,
  OriginalLanguageButton,
  WaypointPopup,
  PhotoPopup,
  TrailHoverCard,
  TrackHoverCard,
  GlobalActions
};
ReactRailsUJS.getConstructor = className => {
  return context[className];
};
